/**
 * Module dependencies.
 */

import { ReactElement, useMemo } from 'react';
import {
  availableFiltersKeys,
  orderedFilters
} from 'src/core/content-config/model-ranges';

import { getKeyFromObject } from 'src/core/utils/objects';
import BaseFilter from 'src/components/filters/base/base-filter';
import BaseFiltersSidebar from 'src/components/filters/filters-sidebar';
import groupBy from 'lodash/groupBy';
import head from 'lodash/head';
import map from 'lodash/map';

/**
 * `Props` type.
 */

type Props = {
  availableFilters: any;
  isOpen: boolean;
  isUpdating: boolean;
  onClose: () => void;
  onUpdate: () => void;
};

/**
 * `FiltersSidebar` component.
 */

const FiltersSidebar = (props: Props): ReactElement => {
  const { availableFilters, isOpen, isUpdating, onClose, onUpdate } = props;
  const normalizedFilters = useMemo(() => {
    const normalizedFilters = [];
    const groupedFilters = groupBy(availableFilters, 'filterType');

    map(Object.keys(groupedFilters), key => {
      const normalizedKey = getKeyFromObject(availableFiltersKeys, key);
      const filterRanges = map(
        groupedFilters[key],
        ({ filterRanges }) => filterRanges
      );

      normalizedFilters[normalizedKey] = head(filterRanges);
    });

    return normalizedFilters;
  }, [availableFilters]);

  return (
    <BaseFiltersSidebar
      isOpen={isOpen}
      isUpdating={isUpdating}
      onClose={onClose}
      onUpdate={onUpdate}
    >
      {map(orderedFilters, filterName => {
        return normalizedFilters[filterName] ? (
          <BaseFilter
            filterName={filterName}
            key={filterName}
            rangesList={normalizedFilters[filterName]}
          />
        ) : null;
      })}
    </BaseFiltersSidebar>
  );
};

/**
 * Export `FiltersSidebar` component.
 */

export default FiltersSidebar;
